if (!customElements.get('deferred-media-switcher')) {
  class DeferredMediaSwitcher extends HTMLElement {
    constructor() {
      super();
      this._observer = null;
    }

    connectedCallback() {
      const targetSelector = this.getAttribute('observe-target');
      if (!targetSelector) {
        console.error('DeferredMediaSwitcher: Missing observe-target attribute.');
        return;
      }

      const targetElement = document.querySelector(targetSelector);
      if (!targetElement) {
        console.error(`DeferredMediaSwitcher: Element ${targetSelector} not found in DOM.`);
        return;
      }

      this._observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this._switchTag();
            this._observer.disconnect();
          }
        });
      }, {
        threshold: 0.1
      });

      this._observer.observe(targetElement);
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
      }
    }

    _switchTag() {
      this.querySelectorAll('deferred-media-lazy').forEach((lazyTag) => {

        const newTag = document.createElement('deferred-media');

        // Copy attributes
        Array.from(lazyTag.attributes).forEach(attr => {
          newTag.setAttribute(attr.name, attr.value);
        });

        // Move children
        while (lazyTag.firstChild) {
          newTag.appendChild(lazyTag.firstChild);
        }

        // Replace in DOM
        lazyTag.replaceWith(newTag);

        // Force connectedCallback if needed (not usually required)
        // newTag.connectedCallback?.();
      });
    }
  }

  customElements.define('deferred-media-switcher', DeferredMediaSwitcher);
}